<div class="grid">
  <div class="col-12">
    <div class="surface-card shadow-2 border-round px-4 py-5 md:px-6 lg:px-8 h-full">
      <h5 class="mb-4 text-900 font-bold">Actividad Anual</h5>
      <p-chart type="bar" height="300px" [data]="operationsData" [options]="basicOptions"></p-chart>
    </div>
  </div>
</div>

<div class="mt-4 surface-card shadow-2 border-round px-4 py-5 md:px-6 lg:px-8">
  <div class="grid">
    <div class="col-12 md:col-6">
      <h5 class="mb-4 text-900 font-bold">Crecimiento de Clientes</h5>
      <p-chart type="line" height="300px" [data]="clientsData" [options]="lineOptions"></p-chart>
    </div>
    <div class="col-12 md:col-6">
      <h5 class="mb-4 text-900 font-bold">Crecimiento de Agentes</h5>
      <p-chart type="line" height="300px" [data]="agentsData" [options]="lineOptions"></p-chart>
    </div>
  </div>
</div>